export const URL_REGEX =
  /^(https?:\/\/)?((([-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z]{2,6})|((\d{1,3}\.){3}\d{1,3})|(\[[0-9a-fA-F:]+\])))(:[0-9]{1,5})?(\/[-a-zA-Z0-9@:%_+.~#?&//=]*)?$/i

export const IP_MASK_REGEX =
  /^((25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)){3})\/(3[0-2]|[12]?\d)$/

export const IP_ADDRESS_REGEX = /^((25[0-5]|(2[0-4]|1\d|[1-9]|)\d)\.?\b){4}$/i

export const EMAIL_REGEX = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i
